module.exports = __webpack_public_path__ + "static/media/homepageBg4.19ea1b66.jpg";